'use client';

import { FC } from 'react';
import { Button, TextField, InputBaseComponentProps } from '@mui/material';
import { PhoneMaskInput } from '@/components';
import { useTranslations } from 'next-intl';
import { Wrapper, LineWrapper, CheckboxLineWrapper, FormTitle, ButtonText } from './styles';
import { Checkbox } from '@/components/common';
import { useBrokerContactForm } from './hooks';

interface BrokerContactFormProps {
  officeId: number;
}

export const BrokerContactForm: FC<BrokerContactFormProps> = ({ officeId }) => {
  const t = useTranslations();
  const { formik, fieldProps, isDisabled } = useBrokerContactForm(officeId);

  return (
    <Wrapper>
      <FormTitle>{t('brokerOfficesDetails.contactFormTitle')}</FormTitle>
      <form onSubmit={formik.handleSubmit}>
        <LineWrapper>
          <TextField
            label={t('housingCardDetails.form.name')}
            size="small"
            fullWidth
            {...fieldProps('name')}
          />
          <TextField
            label={t('housingCardDetails.form.surname')}
            size="small"
            fullWidth
            {...fieldProps('surname')}
          />
        </LineWrapper>

        <LineWrapper>
          <TextField
            label={t('housingCardDetails.form.email')}
            size="small"
            type="email"
            fullWidth
            placeholder="email@example.com"
            {...fieldProps('email')}
          />
        </LineWrapper>

        <LineWrapper>
          <TextField
            label={t('housingCardDetails.form.phone')}
            size="small"
            type="tel"
            fullWidth
            placeholder="+43 000 0000000"
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: PhoneMaskInput as React.ElementType<InputBaseComponentProps>,
            }}
            {...fieldProps('phone')}
          />
        </LineWrapper>

        <LineWrapper>
          <TextField
            label={t('brokerOfficesDetails.yourMessage')}
            size="small"
            multiline
            minRows={3}
            fullWidth
            {...fieldProps('message')}
          />
        </LineWrapper>

        <CheckboxLineWrapper>
          <Checkbox
            label={t('housingCardDetails.callRequest')}
            name="requestCall"
            checked={formik.values.requestCall}
            onChange={formik.handleChange}
          />
          <Checkbox
            label={t('housingCardDetails.acceptGdpr')}
            name="gdprAccepted"
            checked={formik.values.gdprAccepted}
            onChange={formik.handleChange}
            error={!!formik.errors.gdprAccepted}
          />
        </CheckboxLineWrapper>

        <Button
          variant="secondary"
          type="submit"
          disabled={isDisabled}
          sx={{
            height: '44px',
            width: '100%',
            mb: '10px',
          }}
        >
          <ButtonText>{t('housingCardDetails.form.sendRequest')}</ButtonText>
        </Button>
      </form>
    </Wrapper>
  );
};
